"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Spinner = require("./Spinner.styled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Spinner = function Spinner(props) {
  return _react.default.createElement(_Spinner.StyledSpinner, props);
};
/**
 * Definition of default values for component props
 */


exports.Spinner = Spinner;
Spinner.defaultProps = {
  size: '4rem',
  thickness: '8px',
  color: undefined,
  className: undefined,
  id: undefined
};
/**
 * Definition of types for component props
 */

Spinner.propTypes = {
  /** The value for width and height with unit */
  size: _propTypes.default.string,

  /** The value for thikness of the ring and height with unit */
  thickness: _propTypes.default.string,

  /** Color of the spinner */
  color: _propTypes.default.string,

  /** Component className */
  className: _propTypes.default.string,

  /** Component id */
  id: _propTypes.default.string
};